<template>
    <div class="fl-x fl-j-c px-lg-8">
        <div v-if="data" class="row">
            <div class="col-lg-12 pt-4">
                <h3 class="text-primary font-manrope-medium fs-lg-4">Related Blogs</h3>
            </div>
            <div class="col-12 col-lg-6 pt-3" v-for="(item,i) in data.slice(0,2)" :key="i">
                <div class="box-1">
                    <img :src="item.image">
                    <h6 class="font-manrope-semi-bold mb-3 mt-4">
    <span class="author">{{ item.author_name }}</span>

    <img src="../../assets/web/home/dot icon.svg" alt="">

    <span class="date">{{ item.create_date }}</span>
</h6>
                    <h3 class="font-manrope-medium mb-3 text-primary fs-lg-4 ">{{ item.title }}</h3>
                    <p class="mb-5 mb-lg-0mt-4">{{ item.title_description }}</p>
                    <div class="pl-2">
                        <!--                        <btn border-radius="4" design="basic-a" class="font-manrope-medium" size="sm">download</btn>-->

                        <btn @click="openBlogArticlePage(item)" border-radius="4" design="basic-a"
                             class="font-manrope-medium px-4" size="sm">view
                        </btn>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'lastmile',

    props: {
        data: {
            type: Array,
            default: null
        }
    },
    data () {
        return {

        };
    },
    methods: {
        openBlogArticlePage (item) {
            this.$router.push('/blog-article-article/' + item.id + '/details/');
        }
    }
};
</script>

<style scoped>

.box-1{
    display:flex;
    flex-direction:column;
    height:100%;
}

.box-1 img{
    width:100%;
    height:260px;
    object-fit:contain;
    background:#fff;
}

/* Author + Date */
.box-1 h6{
    display:flex;
    align-items:center;
    flex-wrap:wrap;
    gap:8px;
    margin-top:20px;
    margin-bottom:15px;
}

.box-1 h6 span:first-child{
    flex:1;
    min-width:0;
    word-break:break-word;
    overflow-wrap:anywhere;
}

.box-1 h6 span:last-child{
    white-space:nowrap;
}

.box-1 h6 img{
    width:18px;
    height:4px;
}

/* Title */
.box-1 h3{
    min-height:90px;
    word-break:break-word;
    overflow-wrap:anywhere;
    margin-bottom:15px;
}

/* Description */
.box-1 p{
    flex:1;
    text-align:justify;
    word-break:break-word;
    overflow-wrap:anywhere;
    margin-bottom:25px;
}

/* Button always bottom */
.box-1 .pl-2{
    margin-top:auto;
}

@media (max-width:768px){

    .box-1 img{
        height:220px;
    }

    .box-1 h3{
        min-height:auto;
    }

}
</style>
